export { createEmitter } from './emitter.js';
export type { Emitter, EmitterOptions } from './emitter.js';
export { getInstallationId, createInstallationId } from './install-id.js';
export { isTelemetryEnabled, isDebugMode } from './consent.js';
export { getCiInfo } from './ci.js';
export type { CiInfo } from './ci.js';
